/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FolderWrapperWrapper_viewer$ref = any;
export type BulkActionsFolderRendererRendererQueryVariables = {
    readonly userIds: ReadonlyArray<string | null>;
    readonly selectedItemIds: ReadonlyArray<string | null>;
    readonly shouldFillInFolder: boolean;
};
export type BulkActionsFolderRendererRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FolderWrapperWrapper_viewer$ref;
    } | null;
};
export type BulkActionsFolderRendererRendererQuery = {
    readonly response: BulkActionsFolderRendererRendererQueryResponse;
    readonly variables: BulkActionsFolderRendererRendererQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFillInFolder",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "BulkActionsFolderRendererRendererQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FolderWrapperWrapper_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "BulkActionsFolderRendererRendererQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "BulkActionsFolderRendererRendererQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/BulkActionsFolderRendererRendererQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '00acb5a0c83bb2999e5f24a4a0705118';
export default node;
